export const APP_MODAL_OPEN = 'importist/app/MODAL_OPEN';
export const APP_MODAL_CLOSE = 'importist/app/MODAL_CLOSE';
export const APP_LOADING = 'importist/app/LOADING';
export const APP_FETCHING_DATA = 'importist/app/FETCHING_DATA';
export const APP_SET_REDIRECT_PRODUCT_ID = 'importist/app/APP_SET_PRODUCT_ID';
export const APP_IS_TAB_ACTIVE = 'importist/app/IS_TAB_ACTIVE';



// WEBPACK FOOTER //
// ./src/constants.js